import { type EffectOn, type FilterActionTypes, effectOn } from "easy-peasy";

export type LogEffect<Model extends object> = EffectOn<Model> | undefined;

function logAndCount(
  scope: string,
  message: string,
  style?: string,
  ...variables: any[]
) {
  // eslint-disable-next-line no-console
  console.log(`%c${scope} %c${message}`, "color: black", style, ...variables);

  // eslint-disable-next-line no-console
  console.count(`${scope} "${message}" count`);
}

export default function createLogEffect<ModelType extends object>(
  scope: string,
  property: keyof FilterActionTypes<ModelType>,
  enabled = false,
): EffectOn<ModelType> | undefined {
  if (enabled) {
    return effectOn([(state) => state[property]], (_actions, change) => {
      logAndCount(
        `[${scope}]`,
        property.toString(),
        "color: red",
        change.current[0],
      );
    });
  }
}
